import React from "react";
import styled from "styled-components";
import Sperm from "./atoms/Sperm";

export default () => {
  const vasDeferenceDefinitions = (
    <defs>
      <linearGradient
        x1="10.3540532%"
        y1="6.28210663%"
        x2="50%"
        y2="100%"
        id="linearGradient-1"
      >
        <stop stopColor="#83DBD7" offset="0%" />
        <stop stopColor="#43BCB6" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="57.8981983%"
        id="linearGradient-2"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop
          stopColor="#FFFFFF"
          stopOpacity="0.883071588"
          offset="44.0369898%"
        />
        <stop stopColor="#FFFFFF" offset="60.674426%" />
      </linearGradient>
      <linearGradient
        x1="48.4825615%"
        y1="6.26168736%"
        x2="50%"
        y2="47.929364%"
        id="linearGradient-3"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop
          stopColor="#FFFFFF"
          stopOpacity="0.883071588"
          offset="64.2598055%"
        />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
    </defs>
  );

  const Sperm = ({ xOffset = "0", yOffset = "-40" }) =>
    <g className="nature" id={new Date().getTime()}>
      <g transform={"translate(" + xOffset + "," + yOffset + ") rotate(40.0)"}>
        <path
          d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
          id="tail"
          stroke="#FFFFFF"
          strokeWidth="3"
          strokeLinecap="round"
        >
          <animate
            dur="0.35s"
            repeatCount="indefinite"
            attributeName="d"
            values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
            M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
          />
        </path>
        <ellipse
          id="Oval"
          fill="#FFFFFF"
          transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
          cx="40.501453"
          cy="14.2376084"
          rx="8"
          ry="11.8646142"
        />
      </g>
    </g>;

  return (
    <g
      id="Vast-Deference"
      transform="translate(286.004906, 188.406295) scale(-1, 1) rotate(90.000000) translate(-286.004906, -188.406295) translate(120.857716, -81.190230)"
    >
      {vasDeferenceDefinitions}
      <path
        d="M186.458548,20.9211764 C-11.854452,108.097124 14.4068331,258.68583 265.242403,472.687294 L267.707442,466.431581 L275.108051,453.154981 C44.8527432,261.577406 17.2825824,124.89063 192.397569,43.0946512"
        id="vasOutline"
        stroke="#979797"
        strokeWidth="2.5"
        fill="url(#linearGradient-1)"
        transform="translate(165.112302, 246.804235) scale(-1, 1) rotate(15.000000) translate(-165.112302, -246.804235) "
      />
      <path
        d="M87.292472,46.0629345 C188.983214,63.3302528 242.121631,108.161613 246.707723,180.557016 C254.513004,303.770081 108.282629,499.792348 107.528299,498.385442"
        id="spermPath"
        stroke="#FFFFFF"
        strokeWidth="0"
      />
      <path
        d="M87.292472,46.0629345 C170.539825,64.1781679 220.144185,93.0588782 236.105551,132.705065 C250.681955,168.911167 250.681955,205.802562 236,261"
        id="spermPath2"
        stroke="#FFFFFF"
        strokeWidth="0"
      />{" "}
      {/* FLUID */}
      <g id="fluid">
        <g className="fluid">
          <g transform={"translate(0, -35) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -43) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -35) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -43) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -33) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -43) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -33) rotate(40.0)"} fill="34495E">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
        <g className="fluid">
          <g transform={"translate(0, -43) rotate(40.0)"} fill="none">
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#34495E"
              strokeOpacity="0.5"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="1s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
          </g>
        </g>
      </g>
      <g id="sperm" transform="" stroke="#FFFFFF" fill="#FFFFFF">
        <g className="nature">
          <g transform={"translate(0, -40) rotate(40.0)"}>
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="0.35s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
              cx="40.501453"
              cy="14.2376084"
              rx="8"
              ry="11.8646142"
            />
          </g>
        </g>
        <g className="nature">
          <g transform={"translate(0, -25) rotate(40.0)"}>
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="0.35s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
              cx="40.501453"
              cy="14.2376084"
              rx="8"
              ry="11.8646142"
            />
          </g>
        </g>
        <g className="nature">
          <g transform={"translate(0, -45) rotate(40.0)"}>
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="0.35s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
              cx="40.501453"
              cy="14.2376084"
              rx="8"
              ry="11.8646142"
            />
          </g>
        </g>
        <g className="nature">
          <g transform={"translate(0, -35) rotate(40.0)"}>
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="0.35s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
              cx="40.501453"
              cy="14.2376084"
              rx="8"
              ry="11.8646142"
            />
          </g>
        </g>
        <g className="nature">
          <g transform={"translate(0, -50) rotate(40.0)"}>
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="0.35s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
              cx="40.501453"
              cy="14.2376084"
              rx="8"
              ry="11.8646142"
            />
          </g>
        </g>
        <g className="nature">
          <g transform={"translate(0, -40) rotate(40.0)"}>
            <path
              d="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
              id="tail"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <animate
                dur="0.35s"
                repeatCount="indefinite"
                attributeName="d"
                values="M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;
                M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1;
                          M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4;
                          M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9;
                          M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
              />
            </path>
            <ellipse
              id="Oval"
              fill="#FFFFFF"
              transform="translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) "
              cx="40.501453"
              cy="14.2376084"
              rx="8"
              ry="11.8646142"
            />
          </g>
        </g>
      </g>
      <path
        d="M76.5571517,436.676448 L145.63425,436.676448 L145.63425,499.652896 C138.263356,518.154835 131.192031,527.405804 124.420275,527.405804 C117.64852,527.405804 101.694146,518.154835 76.5571517,499.652896 L76.5571517,436.676448 Z"
        id="fadeVasRight"
        fill="url(#linearGradient-2)"
        transform="translate(111.095701, 482.041126) rotate(43.000000) translate(-111.095701, -482.041126) "
      />
      <path
        d="M80.3964834,7.99263106 C92.6585895,-0.455032109 110.029434,2.26090642 132.509018,16.1404467 L116.289635,88.7007084 C106.922005,96.3980018 96.9853349,99.2646965 86.4796247,97.3007924 C75.9739146,95.3368883 68.6636719,83.8899 64.5488966,62.9598276 C64.7226867,33.4738271 70.0052156,15.1514282 80.3964834,7.99263106 Z"
        id="fadeVasLeft"
        fill="url(#linearGradient-3)"
        transform="translate(98.528957, 50.548948) rotate(103.000000) translate(-98.528957, -50.548948) "
      />
    </g>
  );
};



// WEBPACK FOOTER //
// ./src/components/VasDeference.js